import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ScrollingStrip from "./components/ScrollingStrip";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { Container } from "react-bootstrap";
import HomeScreen from "./screens/HomeScreen";
import ProductScreen from "./screens/ProductScreen";
import CartScreen from "./screens/CartScreen";
import LoginScreen from "./screens/LoginScreen";
import RegisterScreen from "./screens/RegisterScreen";
import ProfileScreen from "./screens/ProfileScreen";
import ProtectedRoute from "./components/ProtectedRoute";
import OnlyAdmin from "./components/OnlyAdmin";
import PlaceOrderScreen from "./screens/PlaceOrderScreen";
import OrderScreen from "./screens/OrderScreen";
import UserListScreen from "./screens/UserListScreen";
import UserEditScreen from "./screens/UserEditScreen";
import ProductListScreen from "./screens/ProductListScreen";
import CreateProductScreen from "./screens/CreateProductScreen";
import EditProductScreen from "./screens/EditProductScreen";
import OrderListScreen from "./screens/OrderListScreen";
import AboutUsScreen from "./screens/AboutUsScreen";
import CreateCouponScreen from "./screens/CreateCouponScreen";
import CategoryDiscountScreen from "./screens/CategoryDiscountScreen";
import ShippingAndPaymentScreen from "./screens/ShippingAndPaymentScreen";
import { GlobalLoadingProvider } from "./context/GlobalLoadingContext";
import GlobalLoadingOverlay from "./components/GlobalLoadingOverlay";

const Layout = () => {
  const location = useLocation();
  const showFooter = location.pathname === "/";

  return (
    <>
      <ScrollingStrip />
      <Header />

      <main style={{ flex: "1", backgroundColor:"#f9f9f9" }} className="mt-4 py-4 main-wrapper">
        <Container>
          <Routes>
            <Route path="/product/:id" element={<ProductScreen />} />
            <Route path="/cart" element={<CartScreen />} />
            <Route path="/login" element={<LoginScreen />} />
            <Route path="/register" element={<RegisterScreen />} />
            <Route path="/profile" element={<ProtectedRoute />}>
              <Route path="/profile" element={<ProfileScreen />} />
            </Route>
            <Route path="/shipping-payment" element={<ProtectedRoute />}>
              <Route
                path="/shipping-payment"
                element={<ShippingAndPaymentScreen />}
              />
            </Route>
            <Route path="/placeorder" element={<ProtectedRoute />}>
              <Route path="/placeorder" element={<PlaceOrderScreen />} />
            </Route>
            <Route path="/order/:id" element={<ProtectedRoute />}>
              <Route path="/order/:id" element={<OrderScreen />} />
            </Route>
            <Route path="/admin/users" element={<OnlyAdmin />}>
              <Route path="/admin/users" element={<UserListScreen />} />
            </Route>
            <Route path="/admin/users/edit/:id" element={<OnlyAdmin />}>
              <Route path="/admin/users/edit/:id" element={<UserEditScreen />} />
            </Route>
            <Route path="/admin/products" element={<OnlyAdmin />}>
              <Route path="/admin/products" element={<ProductListScreen />} />
              <Route path="/admin/products/:pageNumber" element={<ProductListScreen />} />
            </Route>
            <Route path="/admin/create-coupon" element={<OnlyAdmin />}>
              <Route index element={<CreateCouponScreen />} />
            </Route>
            <Route path="/admin/category-discounts" element={<OnlyAdmin />}>
              <Route index element={<CategoryDiscountScreen />} />
            </Route>
            <Route path="/admin/products/create" element={<OnlyAdmin />}>
              <Route path="/admin/products/create" element={<CreateProductScreen />} />
            </Route>
            <Route path="/admin/product/edit/:id" element={<OnlyAdmin />}>
              <Route path="/admin/product/edit/:id" element={<EditProductScreen />} />
            </Route>
            <Route path="/admin/orders" element={<OnlyAdmin />}>
              <Route path="/admin/orders" element={<OrderListScreen />} />
            </Route>
            <Route path="/about" element={<AboutUsScreen />} />
            <Route path="/page/:pageNumber" element={<HomeScreen />} />
            <Route path="/search/:keyword/page/:pageNumber" element={<HomeScreen />} />
            <Route path="/search/:keyword" element={<HomeScreen />} />
            <Route index path="/" element={<HomeScreen />} />
            </Routes>
            <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="light"
      />
        </Container>
      </main>

      {showFooter && <Footer />}
    </>
  );
};

const App = () => {
  return (
    <GlobalLoadingProvider>
      <BrowserRouter>
        <GlobalLoadingOverlay />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh",
          }}
        >
          <Layout />
        </div>
      </BrowserRouter>
    </GlobalLoadingProvider>
  );
};


export default App;
